//@ts-nocheck
import { createStore } from 'vuex'
export default createStore({
  state() {
    return {
      imageFile: null,
      isUpload: true,
      currentPrescriptionCode: null,
      countDown: {
        h: 0,
        m: 0,
        s: 0
      },
      userId: ''
    }
  },
  mutations: {
    increment(state, file) {
      // @ts-ignore
      state.imageFile = file
    },
    editIsUpload(state, isTrue) {
      // @ts-ignore
      state.isUpload = isTrue
    },
    editCurrentPrescriptionCode(state, currentPrescriptionCode) {
      // @ts-ignore
      state.currentPrescriptionCode = currentPrescriptionCode;
    },
    editCountDown(state, countDownInput) {
      state.countDown.h = countDownInput.h;
      state.countDown.m = countDownInput.m;
      state.countDown.s = countDownInput.s;
    },
    setUserId(state, id) {
      state.userId = id
      localStorage.setItem('userId', id)
    }
  },
  actions: {
  },
  modules: {
  }
})
